import { render, staticRenderFns } from "./LayoutFooter.vue?vue&type=template&id=aac0d1c0"
import script from "./LayoutFooter.vue?vue&type=script&lang=js"
export * from "./LayoutFooter.vue?vue&type=script&lang=js"
import style0 from "./LayoutFooter.vue?vue&type=style&index=0&id=aac0d1c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports